module.exports = __webpack_public_path__ + "static/media/kurph-webfont.b86cc0b6.ttf";